import { FormHelperText } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import { withStyles } from "@material-ui/core/styles";
import { createBrowserHistory } from "history";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import Loader from "../../../src/components/Loader";
import { isuserexist, TrucklineSignupRegister } from "../../modules/user/redux/action";
import "../../style";
import { isSuperAdmin } from "../Common/CheckAuthorization";
import Button from "../FormElement/Button";
import { validForm } from "../FormElement/FormValidator";
import InputFiled from "../FormElement/InputFiled";
import DataPolicy from "./DataPolicy";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";


const history = createBrowserHistory();

const styles = {
  root: {
    color: "#00bc84",
    "&$checked": {
      color: "#00bc84"
    }
  },
  checked: {}
};

class TrucklineSignup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {
        firstName: "",
        lastName: "",
        username: "",
        password: "",
        // confirmpassword: "",
        counterPartyName: "",
       counterPartyTypeEnum: "",
        counterpartyMemberName: "",
        streetAddress: "",
        city: "",
        state: "",
        code: "",
        phoneNumber: null,
        
        
      },
      formErrors: {
        firstName: "",
        lastName: "",
        username: "",
        password: "",
        // confirmpassword: "",
        counterPartyName: "",
       counterPartyTypeEnum: "",
        counterpartyMemberName: "",
        streetAddress: "",
        city: "",
        state: "",
        code: "",
        phoneNumber: "",
        
      },
      // termsAndConditionAccepted: false,
      // allowDataSharing: false,
      isValid: true,
      Error: "",
      Success: false,
      fetchingComplete: true,
      // openDataPolicy: false
    };
  }
  // handleCheck = event => {
  //   let { name, type, value } = event.target;
  //   if (name === "termsAndConditionAccepted")
  //     this.setState({
  //       termsAndConditionAccepted: !this.state.termsAndConditionAccepted
  //     });
  //   else if (name === "allowDataSharing") {
  //     this.setState({
  //       allowDataSharing: !this.state.allowDataSharing
  //     });
  //   }
  // };

  handleChange = event => {
    const { name, value } = event.target;
    if (name === "phoneNumber") {
      if (value.match(/^\d{0,15}?$/)) {
        this.updateState(name, value);
      }
    } else if (name === "street_address" || name === "city") {
      if (value.match(/^(.|\n){0,100}$/)) {
        this.updateState(name, value);
      }
    } else if (name === "state" || name === "code") {
      if (value.match(/^(.|\n){0,20}$/)) {
        this.updateState(name, value);
      }
    } else if (name === "firstName" || name === "lastName") {
      if (value.match(/^(\w|\ ){0,51}$/)) {
        this.updateState(name, value);
      }
    // } else if (name === "userName") {
    //   if (value.match(/^(\w|\ ){0,51}$/)) {
    //     this.updateState(name, value);
    //   }
    // } else if (name === " counterPartyName" || name === "counterpartyMemberName") {
      if (value.match(/^(\w|\ ){0,51}$/)) {
        this.updateState(name, value);
      }
     else if (name === "counterPartyTypeEnum") {
    
    this.updateState(name, value);
  } 
    } else {
      this.updateState(name, value);
    }
    console.log(this.state.user,'checkkk')
  };

  updateState = (name, value) => {
    this.setState(
      prevState => {
        return {
          user: {
            ...prevState.user,
            [name]: value
          },
          Error: "",
          Success: false,
          fetchingComplete: true
        };
      },
      () => {
        const { user } = this.state;
        const requiredFields = { ...user };
        this.setState({
          isValid: validForm(this.state.formErrors, requiredFields)
        });
      }
    );
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.Error && this.props.Error !== nextProps.Error) {
      this.setState({ Error: nextProps.Error, fetchingComplete: true });
    }
    if (nextProps.Success && this.props.Success !== nextProps.Success) {
      this.setState({
        fetchingComplete: true,
        Success: nextProps.Success,
        user: {
          name: "",
          username: "",
          password: "",
          streetAddress: "",
          phoneNumber: "",
          counterPartyName: "",
         counterPartyTypeEnum: "",
          counterpartyMemberName: "",
        }
      });
    }
  }

  handleError = (name, error) => {
    this.setState(
      prevState => {
        return {
          formErrors: {
            ...prevState.formErrors,
            [name]: error
          }
        };
      },
      () => {
        const { user } = this.state;
        const requiredFields = { ...user };
        this.setState({
          isValid: validForm(this.state.formErrors, requiredFields)
        });
      }
    );
  };

  onCancel = e => {
    e.preventDefault();
    history.goBack();
  };

  userTrucklineSignup = e => {
    e.preventDefault();

    const { user } = this.state;
    const formData = { ...user };
    console.log(formData);
    this.setState({ isValid: true, fetchingComplete: false });
    this.props.actions.TrucklineSignupRegister(formData);
  };

  // validateResetForm = () => {
  //   const { password, confirmpassword } = this.state.user;
  //   if (confirmpassword !== "" || confirmpassword !== null)
  //     return password === confirmpassword;
  //   else return true;
  // };
  
  validateResetForm = () => {
 return true;
  };
  

  openDataPolicyModal = () => {
    this.setState({openDataPolicy : true})
  }

  closeDataPolicyModal = () => {
    this.setState({openDataPolicy : false})
  }

  render() {
    const {
      user,
      isValid,
      Error,
      Success,
      fetchingComplete,
      // termsAndConditionAccepted,
      // allowDataSharing
    } = this.state;
    const { classes } = this.props;
    if (this.props.userData.user.SignUpVerified) {
      return <Redirect to="/subscription" />;
    }
    if (Success) {
      return <Redirect to="/SignUp/success" />;
    }
    if (!fetchingComplete && !(Success || this.props.Error)) {
      return <Loader />;
    }
    return (
      <div className="">
        <div className="textRequired">* Required Cells</div>
        <DataPolicy open={this.state.openDataPolicy} handleClose={this.closeDataPolicyModal}/>
        <div className="mainform">
          <p className="loginHeader">Create Your NTRAC Truckline account</p>

          <InputFiled
            value={user.lastName}
            label="Account Owner Last Name"
            required
            type="text"
            name="lastName"
            validations={["required", "minSize", "maxSize"]}
            handleError={this.handleError}
            handleChange={this.handleChange}
          />
          <InputFiled
            value={user.firstName}
            label="Account Owner First Name"
            required
            type="text"
            name="firstName"
            validations={["required", "minSize", "maxSize"]}
            handleError={this.handleError}
            handleChange={this.handleChange}
          />
          <InputFiled
            value={user.username}
            placeholder="example@mail.com"
            label="Email/Username"
            type="email"
            validations={["username", "required"]}
            handleChange={this.handleChange}
            handleError={this.handleError}
            name="username"
            required
          />
          {Error.length > 0 && <div className="error">{Error}</div>}
          <InputFiled
            label="Password"
            value={user.password}
            required
            handleChange={this.handleChange}
            handleError={this.handleError}
            validations={["password", "required"]}
            type="password"
            name="password"
          />
          <InputFiled
            value={user.counterPartyName}
            label="Broker/Counterparty Name"
            required
            type="text"
            name="counterPartyName"
            validations={["required", "minSize", "maxSize"]}
            handleError={this.handleError}
            handleChange={this.handleChange}
          />
           <FormControl className="formControl">
        <InputLabel id="counterparty-type-label" style={{ fontSize: '16px' }}>Broker/Counterparty Type</InputLabel>
        <Select
          labelId="counterparty-type-label"
          id="counterparty-type"
          value={user.counterPartyTypeEnum}
          onChange={this.handleChange}
          name="counterPartyTypeEnum"
          style={{ fontSize: '16px' }}
        >
          <MenuItem value="">
            Select Counterparty Type
          </MenuItem>
          <MenuItem value="BROKER">Broker</MenuItem>
          <MenuItem value="COUNTERPARTY">Counterparty</MenuItem>
          <MenuItem value="BOTH">Both</MenuItem>
        </Select>
      </FormControl>
           <InputFiled
            value={user.counterpartyMemberName}
            label="Broker/Counterparty Member Name(as it will appear in NTRAC)"
            required
            type="text"
            name="counterpartyMemberName"
            validations={["required", "minSize", "maxSize"]}
            handleError={this.handleError}
            handleChange={this.handleChange}
          />
          <InputFiled
            label="Street Address"
            value={user.streetAddress}
            required
            handleChange={this.handleChange}
            validations={["required"]}
            handleError={this.handleError}
            multiline
            rows={2}
            rowsMax={4}
            type="text"
            name="streetAddress"
          />
          <InputFiled
            label="City"
            value={user.city}
            required
            handleChange={this.handleChange}
            validations={["required"]}
            handleError={this.handleError}
            type="text"
            name="city"
          />
          <InputFiled
            label="State"
            value={user.state}
            required
            handleChange={this.handleChange}
            validations={["required"]}
            handleError={this.handleError}
            type="text"
            name="state"
          />
          <InputFiled
            label="Zip Code"
            value={user.code}
            required
            handleChange={this.handleChange}
            validations={["required"]}
            handleError={this.handleError}
            type="text"
            name="code"
          />
          <InputFiled
            label="Contact Phone Number"
            required
            value={user.phoneNumber}
            handleChange={this.handleChange}
            validations={["required"]}
            handleError={this.handleError}
            type="text"
            name="phoneNumber"
          />
          
          {/* <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={termsAndConditionAccepted}
                  onChange={this.handleCheck}
                  name="termsAndConditionAccepted"
                  classes={{
                    root: classes.root,
                    checked: classes.checked
                  }}
                  style={{paddingTop:'0px'}}
                />
              }
              label={
                <div>
                  <span>I agree to the </span>
                  <Link to="/terms-and-conditions" style={{ color: "#00bc84" }}>
                    Terms and Conditions
                  </Link>{" and "} <br />
                  <span
                  primary
                  onClick={this.openDataPolicyModal}
                  style={{ color: "#00bc84" }}>
                    Data Policy
                  </span>
                  <span> of the website</span>
                </div>
              }
              className="mycheckbox"
            />
          </FormGroup>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={allowDataSharing}
                  onChange={this.handleCheck}
                  name="allowDataSharing"
                  classes={{
                    root: classes.root,
                    checked: classes.checked
                  }}
                />
              }
              label="Opt out from information sharing"
              className="mycheckbox"
            />
          </FormGroup> */}
          {Success.length > 0 && (
            <div className="success">
              {Success} <a href="/login"> Click here</a>
            </div>
          )}

          <div className="signInSection" style={signInSectionStyle}>
          {isSuperAdmin() && 
            <Link
              className="cancelButton"
              component="button"
              onClick={this.onCancel}
            >
            Cancel
          </Link>
          }
            <Button
              name="Continue"
              disabled={
                isValid ||
                !this.validateResetForm() ||
                !fetchingComplete 
                // !termsAndConditionAccepted
              }
              onclick={this.userTrucklineSignup}
              styleClass="signIn"
            />
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    userData: state,
    Error: state.user.Error,
    Success: state.user.Success
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ isuserexist, TrucklineSignupRegister }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(TrucklineSignup));

const signInSectionStyle = {
  display: "flex",
  alignItems: "baseline",
  justifyContent: "space-between"
};



// WEBPACK FOOTER //
// ./src/components/public/TrucklineSignup.js